import { render, staticRenderFns } from "./ho-un-buono.vue?vue&type=template&id=81f895fc&"
import script from "./ho-un-buono.vue?vue&type=script&lang=js&"
export * from "./ho-un-buono.vue?vue&type=script&lang=js&"
import style0 from "./ho-un-buono.vue?vue&type=style&index=0&id=81f895fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports